import { getDeviceList_returns_data_item } from "../getDeviceList";

export const HardCodedDevices: getDeviceList_returns_data_item[] = [
  // {
  //   lat: "17.6644394",
  //   location: "Himadri Chemical, Vizag Plant",
  //   long: "83.2118674",
  //   dev_id: "4171672", // "b433e6aa0de9bef1bcff3ab6abc8f0cb",
  //   loc_id: 315,
  //   district: "Pedagantyada",
  //   aqi: "0",
  // },

  {
    lat: "22.5170370",
    location: "Diamond Beverages Pvt Limited",
    long: "88.2940130",
    dev_id: "11642652", // "b433e6aa0de9bef1bcff3ab6abc8f0cb",
    loc_id: 405,
    district: "South 24 Pgs.",
    aqi: "0",
  },
  // {
  //   lat: "22.871353", //VOC
  //   location: "Himadri Chemicals, Singur Plant",
  //   long: "88.211655",

  //   dev_id: "ab42c3fb27d7ee0ba9832ff23a079d5b",
  //   loc_id: 0,
  //   district: "Hooghly",
  //   aqi: "0",
  // },
];
